import api from "@helpers/api";
import { DemandCreateType } from "@type/procurements/demand";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_TYPE}/procurement-demands`;

export const fetchDemand = async (query: any) => {
  const res = await api.get(apiEndPoint, {
    params: query,
  });

  return res;
};

export const fetchDemandById = async (id: number | string) => {
  const res = await api.get(`${apiEndPoint}/${id}`);

  return res;
};

export const createDemand = async (data: DemandCreateType) => {
  const res = await api.post(apiEndPoint, {
    ...data,
  });

  return res;
};

export const updateDemand = async (id: string | number, data: any) => {
  const res = await api.put(`http://127.0.0.1:7077/settings/demand/${id}`, {
    ...data,
  });

  return res;
};

export const deleteDemand = async (id: string | number) => {
  const res = await api.delete(`http://127.0.0.1:7077/settings/demand/${id}`);

  return res;
};
